import { Component, ViewEncapsulation, OnInit, Input, ElementRef, ViewChild } from "@angular/core";

/**
 * çå­ç»ä»¶ - å¸¸ç¨äºå±ç¤ºæ±æ»æ°æ®ç­çé¢æ¿
 * 
 * <example-url>https://stackblitz.com/edit/np-box-sample?embed=1&file=src/app/app.component.html</example-url>
 */
@Component({
  selector: `np-box`,
  templateUrl: 'box.html',
  styleUrls: ['box.scss'],
  encapsulation: ViewEncapsulation.None
})

export class NpBox implements OnInit {

  /**è¾å¥åæ°éé¡¹ */
  @Input() options: NpBoxOptions;

  @ViewChild('npBoxHeader') private npBoxHeader: ElementRef<HTMLElement>;

  private defaultBgColors = ['blue', 'green', 'red', 'orange'];
  showCustomHoverColor = false;

  constructor() { }

  ngOnInit() {
    this.initOptions();
    this.buildCustomBg();
  }

  private initOptions() {
    if (this.options) {
      if (!this.options.bg) {
        this.options.bg = 'blue';
      }

      if (!this.options.layout) {
        this.options.layout = 'center';
      }
    }
  }

  private buildCustomBg() {
    if (this.options.bg && this.defaultBgColors.indexOf(this.options.bg) === -1 && this.npBoxHeader.nativeElement) {
      if (this.options.bg.indexOf('//') > -1 || this.options.bg.indexOf('http') > -1) {
        this.npBoxHeader.nativeElement.style.backgroundImage = 'url(' + this.options.bg + ')';
        this.npBoxHeader.nativeElement.style.backgroundPosition = '0% 0%';
        this.npBoxHeader.nativeElement.style.backgroundRepeat = 'no-repeat';
        this.npBoxHeader.nativeElement.style.backgroundSize = '100% 100%';
      } else {
        this.npBoxHeader.nativeElement.style.backgroundColor = this.options.bg;
      }
    }
  }

  /**
   * æå»ºNpBoxOptionsä¸­è®¾ç½®çé¼ æ hoveré¢è²hoverColor
   * @param isHover é¼ æ æ¯å¦hover
   */
  buildCustomHoverColor(isHover: boolean) {
    if (this.options.bg && this.options.hoverColor && this.defaultBgColors.indexOf(this.options.bg) === -1) {
      this.showCustomHoverColor = isHover;
    }
  }
}

/**
 * @ignore
 */
export interface NpBoxOptions {
  /**
  * 'blue' | 'green' | 'red' | 'orange'  é»è®¤æä¾åç§å¤´é¨èæ¯é¢è²
  * å¦å¤ä¹å¯ä»¥ç´æ¥ä¼ èæ¯å¾çurlæèå¶ä»é¢è²
  * default = 'blue'
  */
  bg?: string;
  /**å¤´é¨çæ é¢æå­ */
  title: string;
  /**å¤´é¨æ é¢icon */
  faIcon: string;
  /**
   * å½ä¼ å¥çä¸æ¯é»è®¤çåç§é¢è²å¼ä¹ä¸çæ¶åéè¦æä¾hoverçé´å½±é¢è²ï¼åªæ¯æä¼ å¥rgbé¢è²å¼ï¼eg. '100, 100, 100'
   */
  hoverColor?: string;
  /**
   * boxåå®¹å¸å±ï¼å·¦å³å¸å± | å±ä¸­å¸å± | èªå®ä¹å¸å±
   * default = 'center'
   */
  layout?: 'leftRight' | 'center' | 'custom';
  /**åå®¹é¨åçé«åº¦åç´ ï¼ å¦ä¼ å¥'300'åä¸º300px */
  height?: string;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå·¦è¾¹æ é¢ */
  lCaption?: string;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå·¦è¾¹åå®¹ */
  lContent?: any;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå·¦è¾¹åå®¹æå­é¢è² */
  lColor?: string;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå³è¾¹æ é¢ */
  rCaption?: string;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå³è¾¹åå®¹ */
  rContent?: any;
  /**å¦æåå®¹é¨åä¸ºå·¦å³å¸å±ï¼åæ­¤åæ°ä¸ºå³è¾¹åå®¹æå­é¢è² */
  rColor?: string;
  /**å¦æåå®¹é¨åä¸ºå±ä¸­å¸å±ï¼åæ­¤åæ°ä¸ºå±ä¸­åå®¹æ é¢ */
  cCaption?: string;
  /**å¦æåå®¹é¨åä¸ºå±ä¸­å¸å±ï¼åæ­¤åæ°ä¸ºå±ä¸­åå®¹ */
  cContent?: any;
  /**å¦æåå®¹é¨åä¸ºå±ä¸­å¸å±ï¼åæ­¤åæ°ä¸ºå±ä¸­åå®¹æå­é¢è² */
  cColor?: string;
}